import { SelectOptionUi } from '@/components/Select/SelectUi';
import { CfdiUsesResponse } from '@/data/api/model/fiscal/FiscalDto';

export const cfdiUsesResponseToSelectOptionsUi = (
  input?: CfdiUsesResponse
): SelectOptionUi[] =>
  input?.map((item) => ({
    id: item.cfdi_use_id,
    label: `${item.code} ${item.Name}`,
  })) ?? [];
